import controlGroup from "./controlGroup";
import ControlGroupAddon from "./controlGroupAddon";
import ControlGroupButton from "./controlGroupButton";
import ControlGroupCheckbox from "./controlGroupCheckbox";
import ControlGroupInput from "./controlGroupInput";
import ControlGroupItem from "./controlGroupItem";
import ControlGroupSelect from "./controlGroupSelect";

export type { ControlGroupProps } from "./controlGroup";
export type { ControlGroupAddonProps } from "./controlGroupAddon";
export type { ControlGroupCheckboxProps } from "./controlGroupCheckbox";
export type { ControlGroupItemProps } from "./controlGroupItem";
export { controlGroupControlStyles } from "./styles";
export { ControlGroupContext, useControlGroupContext } from "./context";

const ControlGroup = Object.assign(controlGroup, {
  Addon: ControlGroupAddon,
  Button: ControlGroupButton,
  Checkbox: ControlGroupCheckbox,
  Input: ControlGroupInput,
  Item: ControlGroupItem,
  Select: ControlGroupSelect,
});

export default ControlGroup;
